import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./DeleteWidgetPrompt.css";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";

function AddDashboard(props: any) {
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [name, setName] = useState("");
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const userDetails = localStorage.getItem("userInfo");
  const userInfo = JSON.parse(userDetails || "{}");

  // useEffect(() => {
  //   console.log("Name changed:", name);
  // }, [name]);
  useEffect(() => {
    console.log("Printing props before add dashboard:", userInfo);

    console.log("Name in AddDashboard:", name);
    if (props.open) {
      setName(""); // reset the input field each time the dialog opens
      console.log("Name in AddDashboard:", name);
    }
  }, [props.open]);

  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };

  const handlePreviewClose = () => {
    setName("");
    setOpenPreviewDialog(false);
    props.onclose();
  };

  const handlePreviewCloseAdd = async () => {
    const token = localStorage.getItem("token");
    const headers = new Headers({
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    });

    try {
      const response = await fetch(`${vyu_api_url}/dashboard/create`, {
        method: "POST",
        headers: headers,
        body: createDashboardBody,
      });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      if (response.ok) {
        handleSuccess("Dashboard created successfully!"); // Changed message for clarity
      } else {
        const data = await response.json();
        handleError(data.message || "Failed to create Dashboard");
      }
      const json = await response.json();

      console.log("Dashboard created:", json);
      setName("");
    } catch (error) {
      console.error("Error creating dashboard:", error);
    }

    setOpenPreviewDialog(false);
    props.confirmCallBack(props.dataToBeDeleted, true);
    props.onclose();
  };

  const createDashboardBody = JSON.stringify({
    name: name,
    userId: userInfo.userId,
    isDefault: true,
  });
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    console.log(name, "-->", value);
    setName(value);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        keepMounted
        onClose={handlePreviewClose}
        maxWidth="xl"
        BackdropProps={{
          style: { backgroundColor: "transparent" }, // <-- Makes backdrop transparent
        }}
      >
        <div className="outerDiv">
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="deleteWidget-text">Create Dashboard</div>
            </DialogContentText>
            {/* <div style={{ marginTop: "1rem", textAlign: "left" }}>
              <label
                htmlFor="dashboard-name"
                style={{
                  display: "block",
                  marginBottom: "0.3rem",
                  fontSize: "1.5rem",
                  fontWeight: "500",
                  color: "#333",
                }}
              >
                Dashboard Name:
              </label>
              <input
                id="dashboard-name"
                type="text"
                value={name}
                onChange={handleChange}
                placeholder="Enter Dashboard Name"
                className="dashboard-name-input"
                style={{
                  padding: "0.5rem",
                  width: "100%",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div> */}
            <div className="col-lg-12">
              <FormGroup label="Dashboard Name">
                <Input
                  className="shadow-md italic w-full h-10 mb-6"
                  // fullWidth
                  // variant="outlined"
                  id="name"
                  name="name"
                  placeholder="Enter Dashboard Name"
                  value={name}
                  onChange={handleChange}
                />
              </FormGroup>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="nokeepIt-DeleteWidget-wrapper nokeepIt-DeleteWidget">
              <button className="keep" onClick={handlePreviewClose}>
                Cancel
              </button>
            </div>
            <div className="yesDelete-DeleteWidget-wrapper yesDelete-DeleteWidget">
              <button className="confirm" onClick={handlePreviewCloseAdd}>
                Create
              </button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default AddDashboard;
